import React from 'react';
import moment from 'moment';
import EditarFechaFinal from './EditarFechaFinal';

export const SuscripcionRowItem = ({ suscripcion, onUpdate }) => {
  const getEmpresaNombre = (susc) => {
    if (typeof susc.empresa === 'object' && susc.empresa?.nombre) {
      return susc.empresa.nombre;
    }
    return 'N/A';
  };

  const getEstado = (susc) => {
    return susc.estado || 'Desconocido';
  };

  const getFechaCreacion = (susc) => {
    if (susc.createdAt) {
      return moment(susc.createdAt).format('D/M/YYYY');
    }
    if (susc.fechaCreacion) {
      return moment(susc.fechaCreacion).format('D/M/YYYY');
    }
    return 'N/D';
  };

  return (
    <div className='table-row suscripcion-row'>
      <div className='column name'>
        <p>{getEmpresaNombre(suscripcion)}</p>
      </div>
      <div className='column estado'>
        <p>{getEstado(suscripcion)}</p>
      </div>
      <div className='column fecha-final'>
        <EditarFechaFinal
          suscripcion={suscripcion}
          onUpdate={onUpdate}
        />
      </div>
      <div className='column created'>
        <p>{getFechaCreacion(suscripcion)}</p>
      </div>
    </div>
  );
};

